/* MCJ Advanced Search - animated placeholder, image search & voice search
   Inspired by tanishq.co.in | Manik Chand Jewellers customization */
(function () {
  'use strict';

  var ROTATE_PAUSE = 1000; /* ms between rotations */
  var ROTATE_SPEED = 500;  /* ms transition */
  var LINE_H = 28;
  var MAX_FILE = 2 * 1024 * 1024;
  var ENDPOINT = window.MCJ_VISUAL_SEARCH_ENDPOINT || '';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    document.querySelectorAll('.mcj-search-anim').forEach(setupAnim);
    /* Voice search is now handled exclusively by mcj-smart-search.js (instant
       dropdown, no page navigation). The old form-submit voice handler below is
       intentionally NOT called to avoid a double handler that navigated away and
       could submit a mis-heard phrase. */
    /* setupVoice(); */
    setupImageSearch();
  }

  function setupAnim(anim) {
    var field = anim.closest('.field') || anim.parentElement;
    var input = field && field.querySelector('.search__input');
    if (!input) return;

    input.setAttribute('placeholder', '');

    var track = anim.querySelector('.mcj-rotator-track');
    if (track && track.children.length > 1) {
      var clone = track.children[0].cloneNode(true);
      track.appendChild(clone);
      var i = 0;
      var paused = false;

      var step = function () {
        if (paused || !document.body.contains(track)) return;
        i++;
        track.style.transition = 'transform ' + ROTATE_SPEED + 'ms ease';
        track.style.transform = 'translateY(-' + i * LINE_H + 'px)';
        if (i >= track.children.length - 1) {
          setTimeout(function () {
            track.style.transition = 'none';
            track.style.transform = 'translateY(0)';
            i = 0;
          }, ROTATE_SPEED);
        }
      };
      setInterval(step, ROTATE_PAUSE + ROTATE_SPEED);
      anim.addEventListener('mouseenter', function () { paused = true; });
      anim.addEventListener('mouseleave', function () { paused = false; });
    }

    var sync = function () {
      var active = document.activeElement === input || input.value.length > 0;
      anim.classList.toggle('mcj-hidden', active);
    };
    input.addEventListener('focus', sync);
    input.addEventListener('input', sync);
    input.addEventListener('blur', function () { setTimeout(sync, 120); });
    anim.addEventListener('click', function () { input.focus(); });
    sync();
  }

  function setupVoice() {
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    var btns = document.querySelectorAll('.mcj-mic-btn');
    if (!SR) {
      btns.forEach(function (b) { b.style.display = 'none'; });
      return;
    }
    btns.forEach(function (btn) {
      var rec = new SR();
      rec.continuous = false;
      rec.interimResults = false;
      rec.lang = 'en-IN';
      rec.maxAlternatives = 1;
      var listening = false;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (listening) { rec.stop(); return; }
        try { rec.start(); } catch (err) {}
      });
      rec.onstart = function () {
        listening = true;
        btn.classList.add('listening');
        btn.setAttribute('aria-label', 'Listening... speak now');
      };
      rec.onresult = function (ev) {
        var transcript = ev.results[0][0].transcript;
        var form = btn.closest('form');
        var input = form && form.querySelector('.search__input');
        if (input) {
          input.value = transcript;
          var anim = form.querySelector('.mcj-search-anim');
          if (anim) anim.classList.add('mcj-hidden');
          form.submit();
        }
      };
      rec.onerror = function (ev) {
        listening = false;
        btn.classList.remove('listening');
        if (ev.error === 'not-allowed') {
          alert('Microphone permission denied. Please allow microphone access to use voice search.');
        }
      };
      rec.onend = function () {
        listening = false;
        btn.classList.remove('listening');
        btn.setAttribute('aria-label', 'Search by voice');
      };
    });
  }

  function setupImageSearch() {
    var modal = document.getElementById('mcj-imgsearch-modal');
    var camBtns = document.querySelectorAll('.mcj-cam-btn');
    if (!modal) {
      camBtns.forEach(function (b) { b.style.display = 'none'; });
      return;
    }

    var open = function () {
      document.body.classList.add('mcj-modal-open');
      modal.focus();
    };
    var close = function () {
      document.body.classList.remove('mcj-modal-open');
    };

    camBtns.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    modal.querySelector('.mcj-imgsearch-close').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('mcj-modal-open')) close();
    });

    var uploadBtn = modal.querySelector('.mcj-upload-trigger');
    var uploadInput = modal.querySelector('.mcj-image-input:not(.mcj-take-input)');
    var takeBtn = modal.querySelector('.mcj-take-trigger');
    var takeInput = modal.querySelector('.mcj-take-input');
    var status = modal.querySelector('.mcj-imgsearch-status');
    var preview = modal.querySelector('.mcj-preview');
    var previewImg = modal.querySelector('.mcj-preview-img');
    var suggest = modal.querySelector('.mcj-imgsearch-suggest');

    if (uploadBtn && uploadInput) uploadBtn.addEventListener('click', function () { uploadInput.click(); });
    if (takeBtn && takeInput) takeBtn.addEventListener('click', function () { takeInput.click(); });

    [uploadInput, takeInput].forEach(function (inp) {
      if (!inp) return;
      inp.addEventListener('change', function (e) {
        var file = e.target.files[0];
        if (!file) return;
        status.textContent = '';
        suggest.hidden = true;

        if (file.size > MAX_FILE) {
          status.textContent = 'File size should not exceed 2 MB.';
          inp.value = '';
          return;
        }

        var reader = new FileReader();
        reader.onload = function (ev) {
          previewImg.src = ev.target.result;
          preview.hidden = false;
        };
        reader.readAsDataURL(file);

        if (ENDPOINT) {
          status.textContent = 'Searching similar jewellery...';
          var fd = new FormData();
          fd.append('image', file);
          fetch(ENDPOINT, { method: 'POST', body: fd })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              window.location.href = '/search?type=product&q=' + encodeURIComponent(data.query || '');
            })
            .catch(function () {
              status.textContent = 'Something went wrong. Please try again.';
            });
        } else {
          suggest.hidden = false;
        }
      });
    });
  }
})();

/* New-style mobile search: relocate below logo + hide on scroll */
(function () {
  var MOBILE = 989;
  var header = document.querySelector('#sticky-header');
  var row = document.querySelector('.full-width.d-flex.align-items-center');
  var search = document.querySelector('.header_search');
  if (!header || !row || !search) return;

  var origParent = search.parentElement;
  var origNext = search.nextElementSibling;

  function place() {
    if (window.innerWidth <= MOBILE) {
      if (search.parentElement !== header) row.insertAdjacentElement('afterend', search);
    } else {
      if (search.parentElement !== origParent) {
        if (origNext) origParent.insertBefore(search, origNext);
        else origParent.appendChild(search);
      }
      document.body.classList.remove('mcj-search-hidden');
    }
  }
  place();
  window.addEventListener('resize', place, { passive: true });

  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    if (window.innerWidth > MOBILE) { document.body.classList.remove('mcj-search-hidden'); return; }
    var y = window.scrollY;
    if (y > lastY && y > 80) document.body.classList.add('mcj-search-hidden');
    else if (y < lastY) document.body.classList.remove('mcj-search-hidden');
    lastY = y;
  }, { passive: true });
})();